{
  "data_sets": {
    "summary": {
      "dataset_selection": "{{count}} dataset is selected",
      "dataset_selection_plural": "{{count}} datasets are selected",
      "size_info": "Total: {{total}}, Total during import: {{totalImport}}, Remaining: {{accessible}}, Available: {{available}}"
    },
    "hints": {
      "readonly_meaning": "Uncheck readonly to gain rights to modify this dataset"
    },
    "long_import_hint": "Importing may take a lot of time depending on the dataset",
    "categories_list_title": "Categories",
    "categories_grid_title": "Choose datasets to import",
    "no_datasets_in_category": "There are no datasets in this category",
    "database": "Database",
    "search": "Search",
    "dataset_name": "Dataset name",
    "disable_reasons": {
      "dataset_already_queued": "This dataset has already been queued.",
      "dataset_already_importing": "This dataset is currently being imported.",
      "dataset_already_imported": "This dataset has already been imported - please check its status in the dataset tab.",
      "schema_conflict": "Another schema with the name {{schemaName}} already exists in this database.",
      "insufficient_space": "The remaining database space is insufficient to import this dataset."
    },
    "readonly": "Readonly"
  },
  "edit_photo_modal": {
    "title": "Edit Photo",
    "ok_button": "Save",
    "cancel_button": "Cancel"
  },
  "labels": {
    "description": "Description",
    "schema": "Schema"
  },
  "description_panel": {
    "control_icons": {
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "submit": "Save changes",
      "delete": "Delete",
      "manage": "Manage"
    },
    "form": {
      "name": "Name",
      "description": "Description",
      "description_placeholder": "Add a description..."
    }
  },
  "support_form": {
    "title": "Support Form",
    "topic": "Topic",
    "subject": "Subject",
    "message": "Message",
    "confirmation_email": "Send Confirmation Email",
    "submit": "Submit",
    "success_modal": "Thank you for submitting your support ticket. Our support team will review your case and get back to you with a resolution or response as soon as possible."
  },
  "dataset_card": {
    "size_info": "{{finalSize}} ({{importSize}} import size)"
  },
  "jira_support": {
    "title": "Support Desk",
    "new_issue": "New Issue",
    "issues": "Issues",
    "updatedAt": "Updated",
    "no_clusters": "No Clusters",
    "no_projects": "No Projects",
    "no_organizations": "No Organizations",
    "no_description": "No Description Provided",
    "no_comments": "No Comments Yet",
    "yourself": "You",
    "fileUpload": "Upload files",
    "notConfiguredUser": "The Jira Service Desk integration is currently not configured. Please contact your Administrator or Super User.",
    "notConfiguredAdmin": "The Jira Service Desk integration is currently not configured (<b>Settings</b> > <supportLink><b>Support</b></supportLink>).",
    "fetchingRequestTypes": "Fetching request types...",
    "errorFetchingRequestTypes": "Failed to retrieve request types. Please contact the Scalefield team to get the problem resolved.",
    "noRequestTypes": "No request types were found. Please contact the Scalefield team to get the problem resolved.",
    "fetchingRequestTypeFields": "Fetching request information...",
    "errorFetchingRequestTypeFields": "Failed to retrieve request information. Please contact the Scalefield team to get the problem resolved.",
    "noRequestTypeFields": "No request input fields were found. Please contact the Scalefield team to get the problem resolved.",
    "labels": {
      "selectCluster": "Select a cluster",
      "description": "Description",
      "createdAt": "Created At",
      "status": "Status",
      "cluster": "Cluster",
      "supportPlan": "Support Plan",
      "issueKey": "Key",
      "viewIssue": "View Issue",
      "createAnIssue": "Create an Issue",
      "chooseTicketType": "Choose Ticket Type",
      "createIssue": "Create Issue",
      "cancel": "Cancel",
      "organization": "Organization",
      "organizations": "Organizations",
      "projects": "Projects",
      "summary": "Summary",
      "submit": "Submit",
      "close": "Close",
      "issueDetails": "Details",
      "companyName": "Company Name",
      "comments": "Comments",
      "send": "Send",
      "project": "Project",
      "startAt": "Start At",
      "show": "Show",
      "requestStatus": "Request Status"
    }
  },
  "services": {
    "title": "Services",
    "infoButtonTooltip": "Learn more about this product",
    "disabled": {
      "hint": "This service is disabled.",
      "cta": "Contact our team to active it today!"
    },
    "types": {
      "babelfish": {
        "short": "Babelfish",
        "long": "Babelfish",
        "flavor": "Babelfish for PostgreSQL accelerates your journey to migrate SQL Server applications to PostgreSQL",
        "productLink": "https://babelfishpg.org/"
      },
      "cypex": {
        "short": "CYPEX",
        "long": "CYBERTEC Prototyping Express",
        "flavor": "Rapid, scalable, customizable PostgreSQL app development",
        "productLink": "https://www.cybertec-postgresql.com/en/products/cypex/"
      },
      "migrator": {
        "short": "Migrator",
        "long": "CYBERTEC Migrator",
        "flavor": "The fastest, most cost-efficient way to migrate from Oracle to PostgreSQL",
        "productLink": "https://www.cybertec-postgresql.com/en/products/cybertec-migrator/"
      },
      "pgee": {
        "short": "PGEE",
        "long": "CYBERTEC PostgreSQL Enterprise Edition",
        "flavor": "Secure, high-performance PostgreSQL with Transparent Data Encryption and 24/7 enterprise-level support",
        "productLink": "https://www.cybertec-postgresql.com/en/products/cybertec-postgresql-enterprise-edition/"
      },
      "postgres": {
        "short": "PostgreSQL",
        "long": "PostgreSQL",
        "flavor": "The world’s most popular database, preferred by nearly 50% of developers for extensibility, freedom and reliability",
        "productLink": "https://www.postgresql.org/"
      }
    }
  }
}
